import http from "../axios/index.js";

export function logins(data) {
  return http.request({
    method: "POST",
    // contentType: 'application/json',
    url: "/user/login",
    data
  });
}
